import axiosInstance from '../axiosClient';

/**
 * Get all flight logs for an organization
 * @param {string} token - Auth token
 * @param {string} orgUuid - Organization UUID
 * @param {Object} filters - Optional filters (droneId, pilotId, startDate, endDate)
 * @returns {Promise} - Flight logs array
 */
export const getFlightLogs = async (token, orgUuid, filters = {}) => {
  try {
    const response = await axiosInstance.get(`/organization/${orgUuid}/flight-logs`, {
      headers: { Authorization: `Bearer ${token}` },
      params: filters
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get flight logs for a specific drone
 * @param {string} token - Auth token
 * @param {string} orgUuid - Organization UUID
 * @param {number} droneId - Drone ID
 * @returns {Promise} - Flight logs array
 */
export const getDroneFlightLogs = async (token, orgUuid, droneId) => {
  try {
    const response = await axiosInstance.get(`/organization/${orgUuid}/drones/${droneId}/flight-logs`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Add a new flight log
 * @param {string} token - Auth token
 * @param {string} orgUuid - Organization UUID
 * @param {Object} flightLogData - Flight log data
 * @returns {Promise} - Created flight log
 */
export const addFlightLog = async (token, orgUuid, flightLogData) => {
  try {
    const response = await axiosInstance.post(`/organization/${orgUuid}/flight-logs`, flightLogData, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update a flight log
 * @param {string} token - Auth token
 * @param {string} orgUuid - Organization UUID
 * @param {number} flightLogId - Flight log ID
 * @param {Object} updates - Updated fields
 * @returns {Promise} - Updated flight log
 */
export const updateFlightLog = async (token, orgUuid, flightLogId, updates) => {
  try {
    const response = await axiosInstance.patch(`/organization/${orgUuid}/flight-logs/${flightLogId}`, updates, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Delete a flight log
 * @param {string} token - Auth token
 * @param {string} orgUuid - Organization UUID
 * @param {number} flightLogId - Flight log ID
 * @returns {Promise} - Success message
 */
export const deleteFlightLog = async (token, orgUuid, flightLogId) => {
  try {
    const response = await axiosInstance.delete(`/organization/${orgUuid}/flight-logs/${flightLogId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
